export const PARAM_TO_ENUM = (param: string): string | undefined => param?.toUpperCase().replaceAll('-', '_');
export const ENUM_TO_PARAM = (enumStr: string): string | undefined => enumStr?.toLowerCase().replaceAll('_', '-');
